import { reactive } from 'vue';
import router from '@/router';

export const store = reactive({
  aptDone:false, // represents when schedule is finished being written and listened to in clinic
  date:null,
  user: null,
  userObject: null,
  authStateKnown: false, // to preven login screen flasing on page refresh
  path: '',
  scheduleFile: null,
  scheduleData: [],
  newUser: null,
  focusedDate: null,
  // role:'physician', // for dev purposes only, when login writes this can be empty string
  dataIsLoaded:false,
  userRole: null,
  navigationOptions:[{
    name:'Jeff',
    isSelected:false,
    routeName:'heh',
  }],
  secretaryNavigationOptions:[
    {
      name:'Dashboard',
      routeName:'dashboard',
      isSelected:false,
    }
  ],
  physicianNavigationOptions: [
    {
        name: 'New Claim',
        isSelected: false,
        routeName:'appointment',
    },
    {
        name: 'Clinic',
        isSelected: false,
        routeName:'home',
    },
    {
        name: 'View Claims',
        isSelected: false,
        routeName:'view-claims',
    },
    {
      name: 'View Patient',
      isSelected: false,
      routeName:'patient',
    }
]
})


export function setScheduleFile(file: File,) {
  console.log("Setting schedule file in store:", file);
  store.scheduleFile = file;
}

export function setScheduleData(data: Array<Object>){
  store.scheduleData = data;
}

export function setDate(date: string){
  store.date = date;
}

export function setUser(user: any){
  store.user = user;
}

export function userObject(user: any){
  store.userObject = user
  console.log(`JSON STRINGIFY: ${JSON.stringify(store.userObject)}`);
}

export const codeDisplayData = reactive({
    generatedCodes: [],
    apt:null,
    treatmentPlan:null,
    aptOrTreatmentPlan:'',
})

/**
 * Checks route to make sure the correct option is selected on page load
 */
export function toggleCorrectNavigationOption() {
  let foundRole = false;
  const role = store.userRole;
  if(role == 'physician'){
    store.navigationOptions = store.physicianNavigationOptions
  } else if(role == 'secretary'){
    store.navigationOptions = store.secretaryNavigationOptions
  }

    const routeName = router.currentRoute.value.name;
    store.navigationOptions.forEach((option) => {
        if (option.routeName == routeName) option.isSelected = true;
        else option.isSelected = false;
    })
}
